/**
 * Admin Portal → Codes → API — `/admin/codes/api` (Codes PR-8, on `GET /api/admin/codes/api-summary`):
 * every partner API key across partners, its codes in 24 h against its quota, and a link to the codes
 * each key made. Read-only for every role: a key is made, rotated or revoked on its partner's API keys
 * tab (admin roles). Coach Cedar codes are never made through the partner API.
 *
 * Web-only (the admin SPA).
 */

import React from 'react';
import { ApiKeysSummary } from './ApiKeysSummary';
import { CodesHeader, PAGE } from './CodesArea';

export function CodesApi() {
  return (
    <div style={PAGE}>
      <CodesHeader
        title="API"
        subtitle="Every partner API key: the codes it made in the last 24 hours against its daily quota. Make, rotate or revoke a key on its partner's API keys tab."
      />
      <ApiKeysSummary />
    </div>
  );
}

export default CodesApi;
